import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Form} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';
import {withActions} from 'actionware';

import customerApi from '../../store/services/customers';
import FormContainer from '../form-components/FormContainer';
import {fetch} from '../../store/customers';
import CustomerForm from './CustomerForm';
import {ErrorMessages} from '../form-components/ErrorMessages';

class NewCustomerForm extends Component {
  state = {
    loading: false,
    customer: {
      epicorId: '',
      name: '',
    },
    error: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.customer[name] = value;
    });
  };

  _save = () => {
    withLifecycles(
      () => customerApi.create(this.state.customer),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            draft.loading = loading;
            draft.error = error;

            if (data && !data.hasErrors) {
              this.props.fetch();
              this.props.history.push('/manage/customers');
              toastr.success('Customer Created');
            }
          })
        );
      }
    );
  };

  render() {
    const {error, loading, customer} = this.state;
    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <CustomerForm
            customer={customer}
            handleTextChanged={this._handleTextChanged}
            autoFocus
          />
          <ErrorMessages error={error} />
          <Button type="Submit" primary>
            Create
          </Button>
          <Button basic as={Link} to="/manage/customers">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

export default withActions({fetch})(NewCustomerForm);
